module.exports = __webpack_public_path__ + "1cf16ef8e4d6a8242bbfa37b709f29b3.svg";